import React, { useEffect, useState } from "react";
import "./style.scss";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import useDesktopSize from "../../utils/hooks/useDesktopSize";
import ButtonCustom from "../ButtonCustom/ButtonCustom";
import InputText from "../InputText";

interface IProps {
  title: string;
  isOpen?: boolean;
  isButtonOpen?: boolean;
  description?: string;
  inputPlaceholder: string;
  onAccept: (trhId: string) => void;
  errorText: string;
}

const RealizeCodePanel: React.FC<IProps> = ({
  title,
  isOpen = false,
  isButtonOpen = true,
  description,
  inputPlaceholder,
  onAccept,
  errorText
}: IProps) => {
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(isOpen);
  const [trhId, setTrhId] = useState("");

  const onCheckTrhId = async () => {
    onAccept(trhId);
    setTrhId("");
  };

  useEffect(() => {
    if (isDesktop) {
      setOpen(isDesktop);
    }
  }, [isDesktop]);

  return (
    <div className={"realize-code-panel"}>
      <div className={"realize-code-header"} onClick={isDesktop ? () => {} : () => setOpen(!open)}>
        <p>{title}</p>
        {isDesktop && isButtonOpen && (
          <ButtonCustom
            title={`${open ? "-" : "+"}`}
            className={`button-realize-code-color`}
            Icon={open ? AiOutlineMinus : AiOutlinePlus}
            iconPosition={"center"}
            onClick={() => setOpen(!open)}
          />
        )}
      </div>
      {open && (
        <React.Fragment>
          <p>{description}</p>
          <div className={"realize-code-body"}>
            <InputText
              value={trhId}
              label={""}
              name={"trhId"}
              setValue={(value: string) => setTrhId(value)}
              placeholder={inputPlaceholder}
            />
            <ButtonCustom
              title={`Dodaj`}
              className={`button-realize-code-add `}
              onClick={() => onCheckTrhId()}
              disabled={!Boolean(trhId)}
            />
          </div>
          {errorText && (
            <div className={"error-panel"}>
              <p>{errorText}</p>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default RealizeCodePanel;
